export default [
  {
    id: 'f4501095-4133-4c46-91f9-02c0ba247db6',
    path: 'standard-manage',
    name: 'standard-manage',
    meta: { title: '数据标准管理' },
    children: [
      {
        id: '1ad06202-605c-460f-b113-ad299589b19f',
        path: 'standard-list',
        name: 'standard-list',
        component: () => {
          return import('../views/standardManage/standardList')
        },
        meta: {
          title: '标准库管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
          },
        },
      },
      {
        id: '75106754-6fd4-4639-85d9-ac961c52c244',
        path: 'standard-attributes',
        name: 'standard-attributes',
        component: () => {
          return import('../views/standardManage/standardAttributes')
        },
        meta: {
          title: '标准属性管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '522de3fd-9d88-45f2-9c86-a7747cd44ed7',
        path: 'class-list',
        name: 'class-list',
        component: () => {
          return import('../views/standardManage/classList')
        },
        meta: {
          title: '实体管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
            publish: {
              id: 6,
              name: 'publish',
              desc: '发布',
              access: true,
            },
            unpublish: {
              id: 7,
              name: 'unpublish',
              desc: '未发布',
              access: true,
            },
          },
        },
      },
      // {
      //   id: 'd30b2fb0-b542-4dd3-bd99-d937618bea2c',
      //   path: 'entity-type',
      //   name: 'entity-type',
      //   component: () => {
      //     return import('../views/standardManage/entityType')
      //   },
      //   meta: {
      //     title: '实体类型管理',
      //     keepAlive: false,
      //     operations: {
      //       create: {
      //         id: 0,
      //         name: 'create',
      //         desc: '新增',
      //         access: true,
      //       },
      //       update: {
      //         id: 1,
      //         name: 'update',
      //         desc: '编辑',
      //         access: true,
      //       },
      //       delete: {
      //         id: 2,
      //         name: 'delete',
      //         desc: '删除',
      //         access: true,
      //       },
      //       export: {
      //         id: 3,
      //         name: 'export',
      //         desc: '导出',
      //         access: true,
      //       },
      //       import: {
      //         id: 4,
      //         name: 'import',
      //         desc: '导入',
      //         access: true,
      //       },
      //       read: {
      //         id: 5,
      //         name: 'read',
      //         desc: '查看',
      //         access: true,
      //       },
      //       publish: {
      //         id: 6,
      //         name: 'publish',
      //         desc: '发布',
      //         access: true,
      //       },
      //     },
      //   },
      // },
      {
        id: 'ef0273a3-c5f3-4b97-8a1c-51c7b14b6edd',
        path: 'entity-labels',
        name: 'entity-labels',
        component: () => {
          return import('../views/standardManage/entityLabels')
        },
        meta: {
          title: '实体标签',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: 'c8903a71-1c4a-441e-8db7-4eda423b9026',
        path: 'draw-list',
        name: 'draw-list',
        component: () => {
          return import('../views/standardManage/drawlist')
        },
        meta: {
          title: '模型管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '7aa41eba-fd22-4545-9179-7f71d8797f4d',
        path: 'data-model-detail',
        name: 'data-model-detail',
        component: () => {
          return import('../views/standardManage/dataModelDetail')
        },
        meta: {
          title: '数据模型详情',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/standard-manage/draw-list',
        },
      },
      {
        id: '138d9899-1378-4b1f-8381-284ebd386a0f',
        path: 'reference-data',
        name: 'reference-data',
        component: () => {
          return import('../views/standardManage/referenceData')
        },
        meta: {
          title: '参考数据管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      // {
      //   id: 'b74071e9-781b-4636-9933-13be9442edb4',
      //   path: 'class-type',
      //   name: 'class-type',
      //   component: () => {
      //     return import('../views/standardManage/classType')
      //   },
      //   meta: {
      //     title: '类别类型管理',
      //     keepAlive: false,
      //     operations: {
      //       create: {
      //         id: 0,
      //         name: 'create',
      //         desc: '新增',
      //         access: true,
      //       },
      //       update: {
      //         id: 1,
      //         name: 'update',
      //         desc: '编辑',
      //         access: true,
      //       },
      //       delete: {
      //         id: 2,
      //         name: 'delete',
      //         desc: '删除',
      //         access: true,
      //       },
      //       read: {
      //         id: 3,
      //         name: 'read',
      //         desc: '查看',
      //         access: true,
      //       },
      //     },
      //   },
      // },
      {
        id: 'e2ba37c7-aaa3-4cd6-86f2-671eca4f86d8',
        path: 'unit-measure-management',
        name: 'unit-measure-management',
        component: () => {
          return import('../views/standardManage/unitMeasureManagement')
        },
        meta: {
          title: '度量单位管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            export: {
              id: 5,
              name: 'export',
              desc: '导出',
              access: true,
            },
          },
        },
      },
      {
        id: 'dadc11b1-6fc7-4049-ab01-2fc39feafda9',
        path: 'identifier',
        name: 'identifier',
        component: () => {
          return import('../views/standardManage/identifier')
        },
        meta: {
          title: '标识管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
    ],
  },
]
